{
  "welcome": "Welcome, {{name}}",
  "description": "Overview of your account and financial position",
  "nextSettlement": "Next settlement: {{time}}",
  "adminAlert": {
    "title": "Action Required: Initialize Base Principal",
    "description": "You must set your starting base principal (minimum $10,000) before the system can function.",
    "button": "Initialize Base Principal Now"
  },
  "userInfo": {
    "email": "Email",
    "country": "Country",
    "unitedStates": "United States",
    "nonUsa": "Non-USA",
    "countryNote": "(Used for fee rules. Immutable.)",
    "earningEligibility": "Earning Eligibility",
    "eligible": "ELIGIBLE FOR EARNINGS",
    "notEligible": "NOT ELIGIBLE",
    "shortfallNote": "(Need {{amount}} more to reach minimum contribution)"
  },
  "stats": {
    "basePrincipal": "Base Principal",
    "ownership": "Ownership",
    "ownershipTooltip": "Your percentage of the total pool, calculated from S13 ownership snapshot",
    "thisWeeksProfit": "This Week's Profit",
    "withdrawable": "Withdrawable",
    "requestButton": "Request"
  },
  "performance": {
    "title": "Performance Summary",
    "week": "Week-to-Date",
    "month": "Month-to-Date",
    "ytd": "Year-to-Date",
    "allTime": "All-Time"
  },
  "profitSettings": {
    "title": "Profit Settings",
    "notEligibleTag": "NOT ELIGIBLE FOR EARNINGS",
    "reinvestmentPercentage": "Reinvestment Percentage",
    "reinvestmentTooltip": "Drag the slider to adjust what percentage of your weekly profit will be reinvested into your base principal. The remainder will be added to your withdrawable balance.",
    "saveButton": "Save",
    "unsavedChanges": "Unsaved Changes",
    "previewTitle": "Preview (based on current profit):",
    "basePrincipal": "→ Base Principal",
    "withdrawable": "→ Withdrawable",
    "addedOnSettlement": "Added on settlement",
    "notEligibleAlert": {
      "title": "Not Eligible for Earnings",
      "description": "You need to contribute {{amount}} more to reach the minimum required contribution and start earning."
    },
    "saveSuccess": "Reinvestment percentage saved",
    "saveError": "Failed to save reinvestment percentage",
    "invalidPercentage": "Invalid percentage. Must be between 0 and 100."
  },
  "oneTimeWithdraw": {
    "button": "Request withdraw",
    "modalTitle": "One-time Withdrawable Allocation",
    "currentProfit": "Current Profit for Week",
    "amountLabel": "Amount to move to withdrawable",
    "helpText": "This is a one-time allocation that will apply at the next Saturday settlement. It does not change your reinvestment %.",
    "maxError": "Amount cannot exceed current profit for week",
    "minError": "Amount must be greater than or equal to 0",
    "saveButton": "Save",
    "cancelButton": "Cancel",
    "clearButton": "Clear",
    "saveSuccess": "One-time withdrawable amount set successfully",
    "clearSuccess": "One-time withdrawable amount cleared",
    "saveError": "Failed to set one-time withdrawable amount",
    "pendingLabel": "One-time to withdrawable (pending):",
    "remainingNote": "Remaining profit will follow your normal reinvest %."
  },
  "recentAllocations": {
    "title": "Recent Allocations",
    "viewAll": "View All",
    "date": "Date",
    "gross": "Gross",
    "companyCut": "Fees",
    "net": "Net",
    "noAllocations": "No profit allocations yet. Allocations will appear here after profits are distributed."
  },
  "withdrawModal": {
    "title": "Request Withdrawal",
    "processingTime": {
      "title": "Withdrawal Processing Time",
      "description": "Withdrawal requests are typically processed within 1-3 business days."
    },
    "amount": "Amount",
    "available": "(Available: {{amount}})",
    "amountRequired": "Please enter an amount",
    "amountGreaterThanZero": "Amount must be greater than 0",
    "amountExceedsBalance": "Amount exceeds available balance",
    "placeholder": "Enter amount in cents",
    "noteLabel": "Note (Optional)",
    "notePlaceholder": "Add a note about this withdrawal request",
    "cancelButton": "Cancel",
    "submitButton": "Submit Request",
    "submitSuccess": "Withdrawal request submitted successfully",
    "submitError": "Failed to submit withdrawal request"
  },
  "accountClosure": {
    "requestButton": "Request Account Closure",
    "modalTitle": "Request Account Closure",
    "warningTitle": "Important: This action will begin the account closure process",
    "warningMessage": "Once submitted, your request to exit the pool will be processed during the next weekly settlement. Here's what will happen:",
    "step1": "You will receive one final profit allocation in the next settlement",
    "step2": "A final withdrawal will be automatically created for your entire withdrawable balance (including the final profit)",
    "step3": "Your base principal will be set to $0.00",
    "step4": "Your account status will be changed to 'exited' and you will no longer receive profit allocations",
    "explanation": "If you proceed, you will continue to receive one more profit allocation in the upcoming weekly settlement. After that settlement completes, the system will automatically create a final withdrawal for your entire withdrawable balance, and you will no longer participate in future profit distributions.",
    "confirmCheckbox": "I understand that this action cannot be undone and my account will be closed",
    "cancelButton": "Cancel",
    "confirmButton": "Confirm Closure Request",
    "successTitle": "Request Submitted",
    "successMessage": "Your account closure request has been submitted and is pending admin approval. You will no longer receive new profit allocations.",
    "errorTitle": "Request Failed",
    "errorMessage": "Failed to submit closure request. Please try again."
  },
  "closureStatus": {
    "pendingTitle": "Account Closure Pending",
      "pendingMessage": "Your account closure request is pending admin approval. You will no longer receive profit allocations. Once approved, your account will be closed and a final withdrawal will be created for your full balance.",
    "cancelButton": "Cancel Closure Request",
    "exitedTitle": "Account Closed",
    "exitedMessage": "Your account has been closed and you are no longer participating in the pool. No new profits will be allocated to you.",
    "exitedAt": "Effective date",
    "historyAvailable": "You can still view your historical contributions, settlements, and withdrawals below."
  }
}
